import generalSection from "../_section/section.class";
import {adminAccountantsLetterUpload, userAccountantsLetterUpload} from "./upload";
import DataForm from "./DataForm";

export class userAccountantsLetterSection extends generalSection {
    constructor(request, mortgage, props, statementUploadFactory = null) {
        super(request, mortgage, props, statementUploadFactory ?? userAccountantsLetterUpload);
        // Add missing date error

    }
}

export class adminAccountantsLetterSection extends userAccountantsLetterSection {
    constructor(request, mortgage, props) {
        super(request, mortgage, props, adminAccountantsLetterUpload);
        this.DataForm = DataForm
        this.sortByDateProp('documentDate')
        this.activeUpload = this.uploads.find(u => u.allValuesAnswered && u.isVerifiable)
        this.setProblems( this.problemsList.singleUploadUserProblems() )
    }
    getSectionSummary = () => {
        return [
            {
                name: this.personalTitle,
                tags:[{
                    name: 'Dated',
                    value: this.activeUpload?.values?.documentDate?.format('D MMM YYYY') || 'Not Provided'
                }]
            }
        ]
    }
}